// Layout.js
import React, { useEffect } from 'react'
import styled, { keyframes } from 'styled-components'
import { Outlet, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NavBarComponent from './NavbarComponent'
import Footer from './Footer'
import { getLangFromPath } from '../utils/i18nRoutes'

const Layout = () => {
  const location = useLocation()
  const { i18n } = useTranslation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  useEffect(() => {
    const lang = getLangFromPath(location.pathname)
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang)
    }
    document.documentElement.lang = lang
  }, [location.pathname, i18n])

  return (
    <PageShell>
      <NavBarComponent />
      <Main key={location.pathname}>
        <Outlet />
      </Main>
      <Footer />
    </PageShell>
  )
}

export default Layout

const PageShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const Main = styled.div`
  flex: 1 0 auto;
  animation: ${fadeIn} 0.45s ease both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`
